import { apiClient } from './client';
import type { Empresa, TenantCreate, TenantEnvelope, TenantListEnvelope } from './types';

// ── Tenants ──────────────────────────────────────────────────────────────────

/**
 * Listar todos los tenants registrados.
 *
 * GET /api/v1/tenants/
 */
export function listarTenants() {
  return apiClient.get<TenantListEnvelope>('/api/v1/tenants/');
}

/**
 * Obtener detalle de un tenant por su schema_name.
 *
 * GET /api/v1/tenants/{schema_name}/
 */
export function verTenant(schemaName: string) {
  return apiClient.get<TenantEnvelope>(`/api/v1/tenants/${schemaName}/`);
}

/**
 * Crear un nuevo tenant y su dominio asociado.
 * Debe invocarse desde el tenant administrativo.
 *
 * POST /api/v1/tenants/create/
 */
export function crearTenant(data: TenantCreate) {
  return apiClient.post<TenantEnvelope>('/api/v1/tenants/create/', data);
}

/**
 * Eliminar un tenant y su esquema de base de datos.
 * ¡ACCIÓN DESTRUCTIVA!
 *
 * DELETE /api/v1/tenants/{schema_name}/
 */
export function eliminarTenant(schemaName: string) {
  return apiClient.delete<TenantEnvelope & { data: Empresa | null }>(
    `/api/v1/tenants/${schemaName}/`,
  );
}
